import React, {useContext} from "react";
import {useCompanyDetails} from "../../../hooks/useCompanyDetails";
import { useFooterLinks } from "../../../hooks/useFooterLinks";
import FooterBottom from "./FooterBottom";
import FooterTop from "./FooterTop";
import PropTypes from "prop-types";
import * as ROUTES from "../../../common/routes";
import {LocaleContext} from "../../../store/providers/LocaleProvider";

const Footer = ({url}) => {
    const {locale} = useContext(LocaleContext)[0];
    const {companyDetails, error, loading} = useCompanyDetails();
    const {collection} = useFooterLinks();

    // In case top footer needs to be hidden in more pages/conditions, the logic can be added here.
    const isTopFooterHidden = () => {
        if (url?.pathname.replace("/" + locale + "/", "/").startsWith(ROUTES.BOOKING)) {
            return true;
        }

        return false;
    };

    if (error || loading) {
        return null;
    }

    return (
        <>
            {!isTopFooterHidden() &&
                <FooterTop
                    footerCollection={collection}
                    companyDetails={companyDetails}
                />
            }
            <FooterBottom
                companyDetails={companyDetails}
            />
        </>
    );
};

Footer.propTypes = {
    url: PropTypes.object,
};

export default Footer;
